import { DISPLAY_AT } from '@lib/displayAtOptions';
import { ConfigData, TimerType } from '@/types';

export const TIMER_TYPE_OPTIONS = [
	{
		type: TimerType.BAR,
		title: 'Bar',
		description: 'Narrow horizontally aligned timer. Best for the top or bottom of any page.',
	},
	{
		type: TimerType.PRODUCT_CONTAINER,
		title: 'Product container',
		description: 'Small timer with no or solid background. Best for the product page.',
	},
] as const;

/** Anything that is not a known timer type (a missing or hand-edited query parameter) falls back to a bar. */
export function parseTimerType(value: unknown): TimerType {
	return value === TimerType.PRODUCT_CONTAINER ? TimerType.PRODUCT_CONTAINER : TimerType.BAR;
}

/** A new product container starts on product pages with nothing selected — the bar keeps the regular defaults. */
export function applyCreateTimerType(config: ConfigData, timerType: TimerType): ConfigData {
	if (timerType !== TimerType.PRODUCT_CONTAINER) {
		return { ...config, timer_type: TimerType.BAR };
	}

	return {
		...config,
		timer_type: TimerType.PRODUCT_CONTAINER,
		display_at: DISPLAY_AT.PRODUCT,
		categories: [],
		specificPages: [],
		products: [],
	};
}
